"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatsToName = void 0;
exports.FormatsToName = {
    0: 'DEFAULT',
    1: 'PPT',
    2: 'PPTX',
    3: 'DOC',
    4: 'DOCX',
    5: 'JPG',
    6: 'JPEG',
    7: 'PNG',
    8: 'BMP',
    9: 'AVI',
    10: 'MPEG4',
    11: 'MP4',
    12: 'MP3',
    13: 'WAV',
    14: 'PDF',
    15: 'BUNDLE',
    16: 'IMAGE',
    17: 'GIF',
    18: 'TIF',
    19: 'TIFF',
    20: 'ZIP',
    21: 'XLSX',
    22: 'XLS',
    23: 'M4V',
    30: 'PPTXTABLE',
    31: 'DOCXTABLE',
    32: 'YOUTUBE',
    33: 'VIMEO',
    34: 'MPG',
    35: 'MPA',
    36: 'MPE',
    37: 'RM',
    38: 'RAM',
    39: 'ASF',
    40: 'MOV',
    41: 'VOB',
    42: 'WMV',
    43: '3GP',
    44: 'TXT',
    45: 'URL',
    46: 'POTX',
    47: 'WMF',
    48: 'EMF',
    49: 'CSV',
    50: 'XLSM',
    51: 'ARF',
    52: 'EXE',
    53: 'HTML',
    54: 'JSON',
    55: 'GSLIDES',
    56: 'GSHEET',
    57: 'KEY',
    58: 'GDOC',
    99: 'UNKNOWN',
};
//# sourceMappingURL=FormatsToName.js.map